import axios from 'axios';

import IConfiguredJobBoardDTO from '../types/IConfiguredJobBoardDTO';
import IJobBoardLoginDTO from '../types/IJobBoardLoginDTO';
import IPrismSettingsDTO from '../types/IPrismSettingsDTO';

export const getPrismSettings = () => axios.get('api/workspace/prism-settings');

export const savePrismSettings = (payload: IPrismSettingsDTO) =>
  axios.post('api/workspace/prism-settings', payload);

export const getJobBoardSessionSettings = () =>
  axios.get('api/workspace/jobboard-session-settings');

export const getJobBoardLogins = (url: string) => axios.get(url);

export const deleteByEntity = (payload: IConfiguredJobBoardDTO) =>
  axios.post('api/prism-jobboard-logins/delete-by-entity', payload);

export const addJobBoardAccount = (payload: IJobBoardLoginDTO) =>
  axios.post('api/prism-jobboard-logins', payload);

export const getAllPrismSession = () => axios.get('recruitersearch/api/jobboardsession');
export const deleteByPrismSessionId = (id: string) =>
  axios.delete(`recruitersearch/api/jobboardsession/${id}`);
export const getJobBoardSessionById = (id: string) =>
  axios.get(`recruitersearch/api/jobboardsession/${id}`);
